import Ball from '@/assets/graphical-elements/ball.svg'
import {cn} from '@/lib/utils'
import {type IconProps} from '../types'

export const BallIcon = ({className}: IconProps) => <Ball className={cn('fill-current', className)} />
